$(document).ready(function(){
$('.blog-expert-reviews-main').not('.slick-initialized').slick({
    slidesToShow:3,
    slidesToScroll:1,
    autoplay: true,
    infinite:true,    
  	arrows: true,
    adaptiveHeight: false, 
    prevArrow: '<button role="button" aria-label="prev-btn" class="block__section-slick-arrow-coll-main slick-prev-arrow"><span aria-label="prev-btn" class="slide-arrow prev-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.39275 7.37494L8.74525 4.02243L7.86137 3.13855L3 7.99994L7.86137 12.8612L8.74525 11.9774L5.39275 8.62494H13V7.37494H5.39275Z" fill="#26282A"/></svg></span></button>',
    nextArrow: '<button role="button" aria-label="next-btn" class="block__section-slick-arrow-coll-main slick-next-arrow"><span aria-label="next-btn" class="slide-arrow next-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.6073 7.37494L7.25475 4.02243L8.13863 3.13855L13 7.99994L8.13863 12.8612L7.25475 11.9774L10.6073 8.62494H3V7.37494H10.6073Z" fill="#26282A"/></svg></span></button>',
    responsive: [
    {
      breakpoint: 1199,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '70px',
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '80px',
      }
    },
      {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '40px',
      }
    },
      {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '40px',
      }
    } 
  ]
  }); 

// Magnific Popup
  $('.popup-youtube').magnificPopup({
      type: 'iframe',
      iframe: {
        patterns: {
           youtube_short: {
              index: 'youtu.be/',
              id: 'youtu.be/',
              src: 'https://www.youtube.com/embed/%id%?autoplay=1'
          },
          youtube_long: {
            index: 'youtube.com/',
            id: 'v=',
            src: 'https://www.youtube.com/embed/%id%?autoplay=1'
          }
        }
      }
    });

  // Load More
  $(function () {
		$(".blog-expert--filter-main-inner[data-show-old-new='new-to-old'] .blog-expert-reviews-content").slice(0, 12).show();
		$("body").on('click touchstart', '.blog-expert-reviews-button .basic-button', function (e) {
			e.preventDefault();
			$(".blog-expert--filter-main-inner[data-show-old-new='new-to-old'] .blog-expert-reviews-content:hidden").slice(0, 4).slideDown();
			if ($(".blog-expert--filter-main-inner[data-show-old-new='new-to-old'] .blog-expert-reviews-content:hidden").length == 0) {
				$(".blog-expert-reviews-button .basic-button").css('visibility', 'hidden');
			}
		});
	});

  $(function () {
		$(".blog-expert--filter-main-inner[data-show-old-new='old-to-new'] .blog-expert-reviews-content").slice(0, 12).show();
		$("body").on('click touchstart', '.blog-expert-reviews-button .basic-button', function (e) {
			e.preventDefault();
			$(".blog-expert--filter-main-inner[data-show-old-new='old-to-new'] .blog-expert-reviews-content:hidden").slice(0, 4).slideDown();
			if ($(".blog-expert--filter-main-inner[data-show-old-new='old-to-new'] .blog-expert-reviews-content:hidden").length == 0) {
				$(".blog-expert-reviews-button .basic-button").css('visibility', 'hidden');
			}
		});
	});


  $('.blog-expert-reviews-filterleft').click(function(){
    $('.blog-expert-reviews-filterby-popup').toggleClass('blog-expert-reviews-filterby-popup-open');
    $(this).toggleClass('blog-expert-reviews-filterby-closeicon');
  });
  $('.blog-expert-reviews-filterright-text').click(function(){
    $(this).toggleClass('blog-expert-reviews-filterby-sortyby-open');
  });
  $('.blog-review-filter-tags').click(function(){
    $(this).addClass('blog-review-filter-tags-check');
  });

// Old To New and New To Old
  $('.blog-expert-reviews-order span').click(function() {
    $('.blog-expert-reviews-order span').removeClass('active');    
    $(this).addClass('active');
    var selectedSort = $(this).data('sort');
    $('.blog-expert--filter-main-inner').hide();    
    $('.blog-expert--filter-main-inner[data-show-old-new="' + selectedSort + '"]').show();
  });  
  $('.blog-expert-reviews-order span[data-sort="new-to-old"]').click();

// Click event handler for filter links
  $(".blog-expert-reviews-popup-flex .blog-expert-reviews-url").click(function(event) {
    event.preventDefault();
    var targetContent = $(this).closest('.blog-expert-reviews-popup-flex .blog-expert-reviews-url').data('link-article') || $(this).closest('.blog-expert-reviews-url').data('link-url');
    $(".blog-expert-reviews-filter-main .blog-expert-reviews-content").hide();
    $("[data-tag-content='" + targetContent + "']").show();
  });
  
}); 